import { Component, forwardRef, Input, EventEmitter, Output, ViewChild, ElementRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';
import { ItmAbstractControl } from '../itm-abstract-control';
import { ItmDecodeItem } from '../itm-decode-item';

@Component({
	selector: 'itm-combobox',
	templateUrl: './itm-combobox.component.html',
	styleUrls: ['./itm-combobox.component.scss'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => ItmComboboxComponent),
			multi: true
		},
		{
			provide: NG_VALIDATORS,
			useExisting: forwardRef(() => ItmComboboxComponent),
			multi: true
		}
	]
})
export class ItmComboboxComponent extends ItmAbstractControl<ItmComboBoxItem> {
	@ViewChild("controlRef") controlRef: ElementRef;
	getControlRef(): ElementRef {
		return this.controlRef;
	}

	@Input() placeholder: string;
	@Input() list: Array<ItmComboBoxItem>;

	@Output() myChange: EventEmitter<ItmComboBoxItem> = new EventEmitter<ItmComboBoxItem>();

	myOnChange(v: ItmComboBoxItem) {
		this.onChange(v);
		this.myChange.emit(v);
	}

}

export interface ItmComboBoxItem extends ItmDecodeItem { }
